import {
  Box,
  Typography,
  Button,
  Alert,
  AlertTitle,
  Collapse
} from '@mui/material';
import {
  Error as ErrorIcon,
  Refresh as RefreshIcon
} from '@mui/icons-material';

function ErrorState({ 
  error,
  onRetry,
  onClose,
  variant = 'default',
  showRetry = true
}) {
  if (!error) return null;

  const variants = {
    default: {
      wrapper: {
        p: 3,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        textAlign: 'center'
      },
      icon: {
        fontSize: 48,
        color: 'error.main',
        mb: 2
      }
    },
    alert: {
      wrapper: {
        width: '100%'
      }
    },
    inline: {
      wrapper: {
        display: 'flex',
        alignItems: 'center',
        gap: 1
      },
      icon: {
        fontSize: 20,
        color: 'error.main'
      }
    }
  };

  const errorMessage = typeof error === 'string' ? error : error.message || 'An unexpected error occurred';

  if (variant === 'alert') {
    return (
      <Collapse in>
        <Alert 
          severity="error"
          onClose={onClose}
          action={
            showRetry && onRetry && (
              <Button
                color="error"
                size="small"
                startIcon={<RefreshIcon />}
                onClick={onRetry}
              >
                Retry
              </Button>
            )
          }
        >
          <AlertTitle>Error</AlertTitle>
          {errorMessage}
        </Alert>
      </Collapse>
    );
  }

  return (
    <Box sx={variants[variant].wrapper}>
      <ErrorIcon sx={variants[variant].icon} />
      <Typography 
        variant={variant === 'inline' ? 'body2' : 'h6'}
        color="error"
        gutterBottom={variant !== 'inline'}
      >
        {errorMessage}
      </Typography>
      {showRetry && onRetry && variant !== 'inline' && (
        <Button
          variant="outlined"
          color="primary"
          startIcon={<RefreshIcon />}
          onClick={onRetry}
          sx={{ mt: 2 }}
        >
          Try Again
        </Button>
      )}
    </Box>
  );
}

export default ErrorState; 